export default __webpack_public_path__ + "static/media/MyResumeEngUpdated.6244c892.pdf";